// src/components/ListingStatusBadge.jsx
// v9 : ajoute le rendu pour 'manual_check' (domaines bloqués DataDome).
// Affiche un badge orange + un lien "Ouvrir" pour vérification manuelle.

import React from 'react';

export function ListingStatusBadge({ maison, style = {} }) {
  const status = maison?.listing_status;

  if (status === 'removed') {
    const checkedAt = maison.listing_status_checked_at;
    const tooltip = checkedAt
      ? `Vérifié le ${new Date(checkedAt).toLocaleDateString('fr-FR')}`
      : 'Annonce retirée';
    return (
      <span style={{ ...badgeRemovedStyle, ...style }} title={tooltip}>
        ⚠ Annonce retirée
      </span>
    );
  }

  if (status === 'manual_check') {
    const url = maison?.lienAnnonce || maison?.url || maison?.sourceUrl;
    return (
      <span style={{ ...badgeManualStyle, ...style }} title="Ce portail bloque la vérification automatique. Clique pour ouvrir l'annonce et vérifier manuellement.">
        🔍 À vérifier
        {url && (
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            style={linkStyle}
            onClick={(e) => e.stopPropagation()}
          >
            Ouvrir
          </a>
        )}
      </span>
    );
  }

  return null;
}

const badgeRemovedStyle = {
  display: 'inline-block',
  background: 'rgba(220, 38, 38, 0.15)',
  color: '#ef4444',
  border: '1px solid rgba(220, 38, 38, 0.4)',
  borderRadius: '6px',
  padding: '2px 8px',
  fontSize: '11px',
  fontWeight: 600,
  letterSpacing: '0.02em',
};

const badgeManualStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
  background: 'rgba(245, 158, 11, 0.15)',
  color: '#f59e0b',
  border: '1px solid rgba(245, 158, 11, 0.4)',
  borderRadius: '6px',
  padding: '2px 8px',
  fontSize: '11px',
  fontWeight: 600,
  letterSpacing: '0.02em',
};

const linkStyle = {
  color: '#fbbf24',
  textDecoration: 'underline',
  fontWeight: 500,
  marginLeft: 4,
};
